import { render, staticRenderFns } from "./PageTypesOfViolationsAndViolators.vue?vue&type=template&id=2b1aed23&"
import script from "./PageTypesOfViolationsAndViolators.vue?vue&type=script&lang=ts&"
export * from "./PageTypesOfViolationsAndViolators.vue?vue&type=script&lang=ts&"
import style0 from "./PageTypesOfViolationsAndViolators.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
